<template>
    <div>
        <h3 v-if="template||page">{{isTemplate?template.name:page.name}}</h3>
        <div>
            <div class="yq-report-searchbar">
                <el-form inline>
                    <el-form-item label="标题">
                        <el-input v-model="searchModel.titleLike"></el-input>
                    </el-form-item>
                    <el-form-item label="期号">
                        <el-input v-model="searchModel.issueName"></el-input>
                    </el-form-item>
                    <el-form-item label="分类">
                        <el-select v-model="searchModel.category" multiple filterable allow-create default-first-option clearable>
                            <el-option v-for="item in categories" :key="item" :label="item" :value="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="作者">
                        <el-input v-model="searchModel.authorsLike"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="search">搜索</el-button>
                        <el-button v-if="canAdminReport" type="primary" @click="addRow">上传报告</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="yq-report-list" v-if="data">
                <div class="yq-report-item" v-for="report in data.content" :key="report.id">
                    <div class="yq-report-item-cover-picture" :style="{'background-image':getCoverPictureUrl(report)}">
                        <div class="yq-report-item-headline">
                            <div class="yq-report-item-title">{{report.title}}</div>
                            <div class="yq-report-item-subtitle">{{report.category}}-{{report.issueName}}</div>
                            <div class="yq-report-item-authors">{{report.authors}}</div>
                        </div>
                        <div class="yq-report-item-date">
                            <pretty-date-time :value="report.createdAt" format="YYYY-MM-DD"></pretty-date-time>
                        </div>
                    </div>
                    <div class="yq-report-item-toolbar">
                        <el-button-group>
                            <el-button v-if="canAdminReport" icon="el-icon-edit" size="mini" @click="editRow(report)"></el-button>
                            <el-button v-if="canAdminReport" icon="el-icon-delete" size="mini" @click="deleteRow(report)"></el-button>
                            <el-button icon="el-icon-download" size="mini" @click="downloadRow(report)"></el-button>
                        </el-button-group>
                    </div>
                </div>
            </div>
            <div class="foot" v-if="data">
                <el-pagination
                        layout="prev, pager, next" background
                        :total="data.totalElements" :current-page="data.number+1"
                        @current-change="fetchData($event)">
                </el-pagination>
            </div>
        </div>
        <el-dialog v-if="model" :title="model.id?'修改报告':'添加报告'" :visible.sync="dialogFormVisible">
            <el-form ref="form" :model="model" label-width="120px" :rules="rules">
                <el-form-item label="标题" prop="title">
                    <el-input v-model="model.title"></el-input>
                </el-form-item>
                <el-form-item label="期号名" prop="issueName">
                    <el-input v-model="model.issueName"></el-input>
                </el-form-item>
                <el-form-item label="期号数" prop="issueNo">
                    <el-input v-model.number="model.issueNo"></el-input>
                </el-form-item>
                <el-form-item label="分类" prop="category">
                    <el-select v-model="model.category" filterable allow-create default-first-option>
                        <el-option v-for="item in categories" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="作者" prop="authors">
                    <el-input v-model="model.authors"></el-input>
                </el-form-item>
                <el-form-item label="封面图" prop="coverPicture">
                    <attachment v-model="model.coverPicture" tip="大小不超过500K的jpg,png,gif格式图片"
                                max-file-size="500KB" file-suffixes="jpg,jpeg,png,gif"></attachment>
                </el-form-item>
                <el-form-item label="摘要" prop="summary">
                    <el-input v-model="model.summary" type="textarea"></el-input>
                </el-form-item>
                <el-form-item label="报告文档" prop="attachment">
                    <attachment v-model="model.attachment" tip="大小不超过50M的pdf文档"
                                max-file-size="50MB" file-suffixes="pdf"></attachment>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import pageTemplateService from '../../service/page-template'
    import pageService from '../../service/page'
    import reportService from '../../service/report'
    import fileService from '../../service/file'
    import {mapGetters} from 'vuex'

    export default {
        name: "ReportsPage",
        props: ["id", "isTemplate"],
        data() {
            return {
                template: null,
                page: null,
                searchModel: {
                    titleLike: null,
                    issueName: null,
                    category: null,
                    authorsLike: null
                },
                searchParams: {
                    titleLike: null,
                    issueName: null,
                    category: null,
                    authorsLike: null
                },
                categories: [],
                data: null,
                dialogFormVisible: false,
                model: null,
                rules: {
                    title: [
                        {required: true, message: '请输入标题', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'},
                    ],
                    issueName: [
                        {required: true, message: '请输入期号名', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'},
                    ],
                    issueNo: [
                        {required: true, message: '请输入期号数', trigger: 'blur'},
                        {type: 'integer', min: 1, message: '请输入整数', trigger: 'blur'},
                    ],
                    category: [
                        {required: true, message: '请选择分类', trigger: 'blur'}
                    ],
                    authors: [
                        {max: 100, message: '长度100个字符以内', trigger: 'blur'},
                    ],
                    summary: [
                        {max: 200, message: '长度200个字符以内', trigger: 'blur'},
                    ],
                    attachment: [
                        {required: true, message: '请上传报告文档', trigger: 'blur'},
                    ],
                },
            }
        },
        computed: {
            ...mapGetters(['hasAuthority', 'hasAnyAuthority']),
            canAdminReport(){
                return this.hasAuthority('P_前台_管理_舆情报告')
            }
        },
        created(){
            this.init()
        },
        watch:{
            id(){
                this.init()
            }
        },
        methods: {
            async init(){
                if(this.isTemplate){
                    this.template = (await pageTemplateService.getPageTemplate(this.id)).data
                }else{
                    this.page = (await pageService.getPage(this.id)).data
                }
                await this.fetchCategories()
                await this.fetchData(1)
            },
            async fetchCategories(){
                const response = await reportService.listReportCategories()
                this.categories = response.data
            },
            async fetchData(page) {
                const params = Object.assign({},this.searchParams,{page: page - 1, size: 10, sort: 'issueNo,DESC'})
                const response = await reportService.listReports(params)
                this.data = response.data
            },
            search(){
                this.searchParams = JSON.parse(JSON.stringify(this.searchModel))
                this.fetchData(1)
            },
            addRow(){
                this.model = {
                    title: null,
                    attachment: null,
                    coverPicture: null,
                    summary: null,
                    issueName: null,
                    issueNo: null,
                    category: null,
                    authors: null,
                }
                this.dialogFormVisible = true
            },
            editRow(row) {
                reportService.getReport(row.id).then(response => {
                    if(response.data.attachment){
                        response.data.attachment = JSON.parse(response.data.attachment)
                    }
                    if(response.data.coverPicture){
                        response.data.coverPicture = JSON.parse(response.data.coverPicture)
                    }
                    this.model = response.data
                    this.dialogFormVisible = true
                })
            },
            submitForm() {
                this.$refs.form.validate().then(() => {
                    const data = JSON.parse(JSON.stringify(this.model))
                    if(data.attachment){
                        data.attachment = JSON.stringify(data.attachment)
                    }
                    if(data.coverPicture){
                        data.coverPicture = JSON.stringify(data.coverPicture)
                    }
                    if (data.id) {
                        reportService.updateReport(data).then(() => {
                            this.dialogFormVisible = false
                            this.fetchData(this.data.number+1)
                            this.$message({
                                type: 'success',
                                message: '修改成功!'
                            })
                        }).catch(() => {
                            this.$message({
                                type: 'error',
                                message: '修改失败!'
                            })
                        })
                    } else {
                        reportService.addReport(data).then(() => {
                            this.dialogFormVisible = false
                            this.fetchData(this.data.number+1)
                            this.$message({
                                type: 'success',
                                message: '添加成功!'
                            })
                        }).catch(() => {
                            this.$message({
                                type: 'error',
                                message: '添加失败!'
                            })
                        })
                    }
                }).catch(()=>{})
            },
            deleteRow(row){
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    reportService.deleteReport(row.id).then(()=>{
                        if (this.data.content.length > 1) {
                            this.data.content.splice(this.data.content.indexOf(row), 1)
                        } else {
                            this.fetchData(this.data.number>0?this.data.number:1)
                        }
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        })
                    }).catch(()=>{
                        this.$message({
                            type: 'error',
                            message: '删除失败!'
                        })
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            downloadRow(row){
                fileService.downloadFile(JSON.parse(row.attachment)[0])
            },
            getCoverPictureUrl(row){
                if(row.coverPicture){
                    const url = fileService.getFileUrl(JSON.parse(row.coverPicture)[0])
                    return 'url("'+url+'")'
                }else{
                    return null
                }
            }
        }
    }
</script>
<style scoped>

</style>
